import React from 'react';
import { currencyOfferDetailFormat } from './offerDetailFormats';
import OfferDetail from './OfferDetail';

const CurrencyOfferDetail = ({ name, value }) => (
  <OfferDetail format={currencyOfferDetailFormat} name={name} value={value} />
);

export default CurrencyOfferDetail;
